import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, Row, Col, message, DatePicker, Typography, Spin, } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import { SUBMISSION_FAILED, COMMON_ERROR_MSG } from "../../constants/constants";
import { routes } from "../../routes/Routes"
import PhoneInput from "react-phone-input-auto-format";
import IntegerInput from "../../components/IntergerInput";
import MaskedDigitsInput from "../../components/MaskedDigitsInput";
import ShowApplicationId from "../NewApplication/ShowApplicationId";
import moment from "moment";
import ApplicationProgressBar from "./ApplicationProgressBar";
import { LeftOutlined, RightOutlined, ArrowRightOutlined } from '@ant-design/icons';
import ButtonComponent from "../../components/Button/Button";
import "./ApplicantsIdentification.scss";
const { Option } = Select;

const { Title } = Typography;
// const fileFormatText = (
//     <Text type="secondary" style={{ fontSize: 12 }}>
//         Format: png, jpeg &nbsp; &nbsp; Size: 155k-350k
//     </Text>
// );

const ApplicantsIdentification = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [form] = Form.useForm();
    // const [imagePath, setImagePath] = useState(undefined);
    // const [imagePathValue, setImagePathValue] = useState(undefined);
    // const [file, setFile] = useState({});
    const [idtypes, setidtypes] = useState([]);
    const [applicantInfo, setApplicantInfo] = useState({});
    // const [imageUrl, setimageUrl] = useState(undefined);
    // const [uploading, setUploading] = useState(false);

    let Id = localStorage.getItem("Id");
    let emailId = localStorage.getItem("ApplicationEmailId");
    let APPLICATION_TYPE_ID = localStorage.getItem("applicationTypeId");
    let SponserIdForFirmLogin = localStorage.getItem("SponserIdForFirmLogin");
    const applicationId = localStorage.getItem("ApplicationId");

    const location = useLocation();
    let data = location.state;
    let applnObjId = "";
    let activeKeyTab = null;
    let fromDashboard = false;

    if (data && data.applicationObjId) {
        applnObjId = data.applicationObjId;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }

    if (data && data.isFromDashboard) {
        fromDashboard = data.isFromDashboard;
    }

    if (data && data.activeKey) {
        activeKeyTab = data.activeKey;
    }

    const [appObjId] = useState(applnObjId);
    const [isFromDashboard] = useState(fromDashboard);
    const [tabActiveKey] = useState(activeKeyTab);

    useEffect(() => {
        getidtypes();
        // uploadImageToServer();
        // getApplicantInformationByApplicationId();
        // getSponserDataByApplicantEmail();
    }, []);

    useEffect(() => form.resetFields(), [applicantInfo]);



    useEffect(() => {
        fetchApplicantAndSponsorData();
    }, []);

    // Upload image to server
    // const uploadImageToServer = async (file) => {
    //     const formData = new FormData();
    //     formData.append("files[]", file);
    //     // formData.append("ScreenName", "applicantphotoimage");
    //     // formData.append("ApplicationId", localStorage.getItem("Id"));
    //     let ApplicationId = localStorage.getItem("Id");
    //     setUploading(true);
    //     try {
    //         const res = await _NewapplicationService.UploadPhotoImage(formData, ApplicationId, "applicantphotoimage");

    //         // const applicationId = localStorage.getItem("ApplicationId");
    //         // const res = await fetch(
    //         //   `http://98.70.41.158:9090/api/UploadImages/UploadPhotoImage?uploadPhotoName=coborrowerphotoimage&applicationId=8`,
    //         //   {
    //         //     method: "POST",
    //         //     body: formData,
    //         //   }
    //         // );

    //         // debugger
    //         if (res?.data?.IsSucess && res?.data?.Message) {
    //             //debugger
    //             let relativePath = new URL(res.data.URL).pathname;
    //             setImagePath(relativePath);
    //             setimageUrl(res.data.URL);

    //             notification.success({
    //                 description: res?.data?.Message,
    //                 icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
    //                 duration: 3,
    //                 placement: "top"
    //             });
    //             setUploading(false);
    //         } else {
    //             setUploading(false);
    //             notification.error({
    //                 message: "Upload Failed",
    //                 description: res?.data?.Message || `${file.name} failed to upload.`,
    //                 icon: <CloseCircleOutlined style={{ color: "#ff4d4f" }} />,
    //                 duration: 3,
    //                 placement: "top"
    //             });
    //         }


    //     } catch (err) {
    //         console.error("Upload error:", err);
    //         setUploading(false);
    //         // message.error(err.message || "Server error during image upload");
    //         return null;
    //     }
    // };

    const fetchApplicantAndSponsorData = async () => {
        try {
            setLoading(true);

            const [applicantRes, sponsorRes] = await Promise.all([
                _NewapplicationService.getApplicantInformationByApplicationId(isFromDashboard ? appObjId : Id),
                _NewapplicationService.getSponserDataByApplicantEmail(emailId, SponserIdForFirmLogin),
            ]);

            const sponsor = sponsorRes?.data?.Obj;
            const applicant = applicantRes?.data;
            console.log(sponsor, "sponsor data")
            console.log(applicant, "applicant data")
            const formValues = {};

            if (applicant) {
                formValues.iDType = applicant.Ident_Type_Id;
                formValues.identificationNumber = applicant.Ident_Identification_Number;
                formValues.dateOfIssue = applicant.Ident_Date_Of_Issue ? moment(applicant.Ident_Date_Of_Issue) : null;
                formValues.expirationDate = applicant.Ident_Expiration_Date ? moment(applicant.Ident_Expiration_Date) : null;
                formValues.stateOfIssue = applicant.Ident_State_Of_Issue;
                formValues.nationality = applicant.Ident_Nationality;
                formValues.physicalAddress = applicant.Ident_Physical_Address;
                formValues.city = applicant.Ident_City;
                formValues.state = applicant.Ident_State;
                formValues.zipcode = applicant.Ident_ZipCode;
                formValues.ssnumber = applicant.Ident_SSN_Number;
                formValues.yearsOfResidence = applicant.Ident_Years_Of_Residence;
                // formValues.PhotoOfID = applicant.Ident_Photo_Of_Id_Path;

                // Only apply employer fields from applicant if sponsor info is missing
                formValues.employerName = applicant.Sp_EmployerName;
                formValues.employerBusinessPhone = applicant.Sp_BusinessPhone || "";
                formValues.employerStreetAddress = applicant.Sp_StreetAddress;
                formValues.employerCity = applicant.Sp_City;
                formValues.employerState = applicant.Sp_State;
                formValues.employerZip = applicant.Sp_ZipCode;
                formValues.employerNoofYears = applicant.Sp_NoOfYears;
                formValues.employerPositionTitle = applicant.Sp_PositionTitle;
                formValues.employerNoofDependents = applicant.Sp_NoOfDependant;
                formValues.employerAgeOfDependents = applicant.Sp_AgeOfDependant || null;
                formValues.Application_Status_Id = applicant.Application_Status_Id;

                // formValues.CoB_Ident_Physical_Address = applicant.CoB_Ident_Physical_Address;
                // formValues.CoB_Ident_City = applicant.CoB_Ident_City;
                // formValues.CoB_Ident_State = applicant.CoB_Ident_State;
                // formValues.CoB_Ident_ZipCode = applicant.CoB_Ident_ZipCode;
                // formValues.CoB_Ident_Address_Type = applicant.CoB_Ident_Address_Type;

                // setImagePath(applicant.Ident_Photo_Of_Id_Path);
                // setImagePathValue(applicant.Ident_Photo_Of_Id_Path);
            }

            // Overwrite with sponsor data if available
            if (sponsorRes?.data?.IsSuccess && sponsor) {
                formValues.employerName = sponsor.CompanyName;
                formValues.employerBusinessPhone = sponsor.ContactNumber ? sponsor.ContactNumber : applicant.Sp_BusinessPhone ? applicant.Sp_BusinessPhone : "";
                formValues.employerStreetAddress = sponsor.StreetAddress;
                formValues.employerCity = sponsor.City;
                formValues.employerState = sponsor.State;
                formValues.employerZip = sponsor.ZipCode;
            }

            form.setFieldsValue(formValues);
            setApplicantInfo(formValues);
        } catch (error) {
            console.error("Error loading applicant/sponsor data", error);
            message.error("Failed to load applicant and sponsor data");
        } finally {
            setLoading(false);
        }
    };


    // const getSponserDataByApplicantEmail = async () => {
    //     try {
    //       const res = await _NewapplicationService.getSponserDataByApplicantEmail(emailId);
    //       const data = res.data;
    //       if (data?.IsSuccess && data?.Obj) {
    //         const sponsor = data.Obj;
    //         form.setFieldsValue({
    //           employerName: sponsor.ApplicantName,
    //           employerBusinessPhone: sponsor.BusinessPhone,
    //           employerStreetAddress: sponsor.StreetAddress,
    //           employerCity: sponsor.City,
    //           employerState: sponsor.State,
    //           employerZip: sponsor.ZipCode,

    //         });
    //       } else {
    //         message.warning("Sponsor data not found");
    //       }
    //     } catch (error) {
    //       console.error("Error fetching sponsor data:", error);
    //       message.error("Failed to fetch sponsor data");
    //     }
    //   };

    const onFinish = async (values) => {
        const dateOfIssue = values.dateOfIssue?.format("YYYY-MM-DD");
        const expirationDate = values.expirationDate?.format("YYYY-MM-DD");
        setLoading(true);
        let reqObj = {
            Id: localStorage.getItem("Id"),
            ScreenName: "aapplicationidentification",
            ApplicationId: localStorage.getItem("ApplicationId"),
            Ident_Type_Id: values.iDType,
            Ident_Identification_Number: values.identificationNumber,
            Ident_Date_Of_Issue: dateOfIssue,
            Ident_Expiration_Date: expirationDate,
            Ident_State_Of_Issue: values.stateOfIssue,
            Ident_Nationality: values.nationality,
            Ident_Physical_Address: values.physicalAddress,
            Ident_City: values.city,
            Ident_State: values.state,
            Ident_ZipCode: values.zipcode,
            Ident_SSN_Number: values.ssnumber,
            Ident_Years_Of_Residence: values.yearsOfResidence,
            // Ident_Photo_Of_Id_Path: imagePath,

            // CoB_Ident_Physical_Address: applicantInfo && applicantInfo.CoB_Ident_Address_Type ? values.physicalAddress : applicantInfo.CoB_Ident_Physical_Address,
            // CoB_Ident_City: applicantInfo && applicantInfo.CoB_Ident_Address_Type ? values.city : applicantInfo.CoB_Ident_City,
            // CoB_Ident_State: applicantInfo && applicantInfo.CoB_Ident_Address_Type ? values.state : applicantInfo.CoB_Ident_State,
            // CoB_Ident_ZipCode: applicantInfo && applicantInfo.CoB_Ident_Address_Type ? values.zipcode : applicantInfo.CoB_Ident_ZipCode,

            Sp_EmployerName: values.employerName,
            Sp_BusinessPhone: values.employerBusinessPhone,
            Sp_StreetAddress: values.employerStreetAddress,
            Sp_City: values.employerCity,
            Sp_State: values.employerState,
            Sp_ZipCode: values.employerZip,
            Sp_NoOfYears: values.employerNoofYears,
            Sp_PositionTitle: values.employerPositionTitle,
            Sp_NoOfDependant: values.employerNoofDependents,
            Sp_AgeOfDependant: values.employerAgeOfDependents,
            IsAapplicationIdentificationCompleted: true,
        }
        try {
            const res = await _NewapplicationService.submitApplicantData(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message);

                if (isFromDashboard) {
                    history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
                } else {
                    if (APPLICATION_TYPE_ID == "3") {
                        history.push({ pathname: routes.uploaddocuments.path });
                    } else if (APPLICATION_TYPE_ID == "4") {
                        history.push({ pathname: routes.coBorrowersDetails.path });
                    } else {
                        history.push({ pathname: routes.uploaddocuments.path });
                    }
                }
            } else {
                setLoading(false);
                message.error(res.data.message ? res.data.message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.message || SUBMISSION_FAILED);
        }
        finally {
            setLoading(false);
        }

    };

    // const getApplicantInformationByApplicationId = async () => {
    //     try {
    //         setLoading(true);
    //         const res = await _NewapplicationService.getApplicantInformationByApplicationId(isFromDashboard ? appObjId : Id);
    //         console.log("ab res", res)
    //         if (res.data) {
    //             let resObj = res?.data;

    //             setApplicantInfo({
    //                 iDType: resObj.Ident_Type_Id,
    //                 identificationNumber: resObj.Ident_Identification_Number,
    //                 dateOfIssue: resObj.Ident_Date_Of_Issue ? moment(resObj.Ident_Date_Of_Issue) : null,
    //                 expirationDate: resObj.Ident_Expiration_Date ? moment(resObj.Ident_Expiration_Date) : null,
    //                 stateOfIssue: resObj.Ident_State_Of_Issue,
    //                 nationality: resObj.Ident_Nationality,
    //                 physicalAddress: resObj.Ident_Physical_Address,
    //                 city: resObj.Ident_City,
    //                 state: resObj.Ident_State,
    //                 zipcode: resObj.Ident_ZipCode,
    //                 yearsOfResidence: resObj.Ident_Years_Of_Residence,
    //                 PhotoOfID: resObj.Ident_Photo_Of_Id_Path,
    //                 employerName:resObj.Sp_EmployerName,
    //                 employerBusinessPhone:resObj.Sp_BusinessPhone,
    //                 employerStreetAddress:resObj.Sp_StreetAddress,
    //                 employerCity:resObj.Sp_City,
    //                 employerState:resObj.Sp_State,
    //                 employerZip:resObj.Sp_ZipCode,

    //               });

    //             setLoading(false);
    //         }
    //     } catch (e) {
    //         setLoading(false);
    //         console.log(e);
    //     }
    // };

    const onBack = () => {
        if (isFromDashboard) {
            history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        } else {
            if ((APPLICATION_TYPE_ID == "1" || APPLICATION_TYPE_ID == "4")) {
                history.push(routes.ApplicantsDetails.path);
            } else if (APPLICATION_TYPE_ID == "3") {
                history.push(routes.ProofOfTrust.path);
            }
        }
    }

    const getidtypes = async () => {
        try {
            const res = await _NewapplicationService.getAllDropdownDataByName("idtypes");
            if (res.data) {
                setidtypes(res.data);
            }
        } catch (e) {
            console.log(e);

        }
    };

    // const preventRequest = async (file) => {
    //     // const isValidType = file?.type === "image/png" || file?.type === "image/jpeg";
    //     // const isGt155KB = file?.size >= 155 * 1024; // 158720 bytes
    //     // const isLt350KB = file?.size <= 350 * 1024; // 358400 bytes

    //     // if (!isValidType) {
    //     //     message.error("Only JPG/PNG files allowed!");
    //     //     setFile(undefined);
    //     //     setImagePathValue(undefined);
    //     //     return Upload.LIST_IGNORE;
    //     // }

    //     // if (!isGt155KB || !isLt350KB) {
    //     //     message.error("Image size must be between 155KB and 350KB!");
    //     //     setFile(undefined);
    //     //     setImagePathValue(undefined);
    //     //     return Upload.LIST_IGNORE;
    //     // }

    //     // const uploadedPath = await uploadImageToServer(file);

    //     // if (uploadedPath) {
    //     //     setImagePath(uploadedPath); // backend path
    //     //     setImagePathValue("test"); // preview
    //     //     setFile(file);
    //     // }

    //     // return false; // prevent antd default upload

    //     if (
    //         file &&
    //         file.type &&
    //         file.type.toLowerCase().includes("image") &&
    //         file.size <= 10000000 && file?.size >= 155 * 1024 && file?.size <= 350 * 1024
    //     ) {
    //         const uploadedPath = await uploadImageToServer(file);

    //         if (uploadedPath) {
    //             setImagePath(uploadedPath);
    //             setFile(file);
    //             setImagePathValue("test");
    //         }
    //         return false;
    //     } else {
    //         setFile(undefined);
    //         setImagePathValue(undefined);
    //         const isValidType = file?.type === "image/png" || file?.type === "image/jpeg";
    //         const isGt155KB = file?.size >= 155 * 1024; // 158720 bytes
    //         const isLt350KB = file?.size <= 350 * 1024; // 358400 bytes

    //         if (!isValidType) {
    //             message.error("Only JPG/PNG files allowed!");
    //             return Upload.LIST_IGNORE;
    //         }

    //         if (!isGt155KB || !isLt350KB) {
    //             message.error("Image size must be between 155KB and 350KB!");
    //             return Upload.LIST_IGNORE;
    //         }
    //     }
    // };

    // const removeFile = () => {
    //     setFile({});
    //     setImagePath(undefined);
    //     setImagePathValue(undefined);
    // };

    // const onDeleteImage = () => {
    //     confirm({
    //         title: "Are you sure, want to delete this Photo Of ID?",
    //         icon: <ExclamationCircleOutlined />,
    //         okText: <span id="yesBtn">Yes</span>,
    //         cancelText: <span id="noBtn">No</span>,
    //         okType: "primary",
    //         onOk() {
    //             onCancelImage();
    //         }
    //     });
    // };

    // const onCancelImage = async () => {
    //     setFile(undefined);
    //     form.setFieldsValue({ PhotoOfID: "" });
    //     setImagePath(undefined);
    //     setImagePathValue(undefined);
    //     setApplicantInfo({ ...applicantInfo, PhotoOfID: null });
    // };

    const disableFutureDates = (current) => {
        return current && current > moment().endOf("day");
    };

    return (
        <Spin spinning={loading}>
            <LeftLayout>
                <div>
                    {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                        <div>
                            <ApplicationProgressBar />
                            <Title level={5}>
                                {/* <ShowApplicationId /> */}
                            </Title>
                        </div>
                    )}
                </div>
                <div className="pageLayoutWrapper">
                    {/*  <div className="application-card"> */}

                    <Row>
                        <Col span={24} >
                            <Title level={3} style={{ marginBottom: 25 }}>Client Identification</Title>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onFinish}
                                initialValues={applicantInfo}
                            >
                                {/* <div className="card-section">

                                    <div>

                                        <Title level={5} style={{ marginBottom: 25 }}>Identification Details</Title>
                                        <Form.Item
                                            label="ID Type"
                                            name="iDType"
                                            className="w50"
                                            rules={[{ required: true, message: 'ID Type is required' }]}
                                        >
                                            <Select placeholder="Select ID Type">
                                                {idtypes.map((type) => (
                                                    <Option key={type.Name} value={type.Id}>
                                                        {type.Name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>



                                        <Form.Item
                                            label="ID Number"
                                            name="identificationNumber"
                                            className="w50"
                                            rules={[{ required: true, message: "ID Number is required" }]}
                                        >
                                            <MaskedDigitsInput placeholder="Enter ID Number" maxLength={30}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    const sanitized = value.replace(/[^a-zA-Z0-9]/g, ''); // Only letters and numbers
                                                    form.setFieldsValue({ identificationNumber: sanitized });
                                                }} />
                                        </Form.Item>



                                        <Form.Item
                                            label="Date Of Issue"
                                            name="dateOfIssue"
                                            className="w50"
                                            rules={[{ required: true, message: "Date Of Issue is required" }]}
                                        >
                                            <DatePicker placeholder="Select Date Of Issue" style={{ width: "100%" }} format="MM/DD/YYYY" disabledDate={disableFutureDates} />
                                        </Form.Item>


                                        <Form.Item
                                            label="Expiration Date"
                                            name="expirationDate"
                                            className="w50"
                                            dependencies={['dateOfIssue']} // ensures the validator re-runs when this changes
                                            rules={[
                                                { required: true, message: "Expiration Date is required" },
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        const dateOfIssue = getFieldValue('dateOfIssue');
                                                        if (!value || !dateOfIssue) {
                                                            return Promise.resolve();
                                                        }
                                                        if (value.isAfter(dateOfIssue, 'day')) {
                                                            return Promise.resolve();
                                                        }
                                                        if (value.isSame(dateOfIssue, 'day')) {
                                                            return Promise.reject(new Error('Expiration Date must be greater than Date Of Issue'));
                                                        }
                                                        return Promise.reject(new Error('Expiration Date must be greater than Date Of Issue'));
                                                    },
                                                }),
                                            ]}
                                        >
                                            <DatePicker
                                                placeholder="Select Expiration Date"
                                                style={{ width: "100%" }}
                                                format="MM/DD/YYYY"
                                                disabledDate={(current) => current && current.isBefore(moment(), "day")}
                                            />
                                        </Form.Item>

                                        <Form.Item
                                            label="State Of Issue"
                                            name="stateOfIssue"
                                            className="w50"
                                            rules={[{ required: true, message: "State Of Issue is required" }]}
                                        >
                                            <Input placeholder="Enter State Of Issue" maxLength={30} />
                                        </Form.Item>


                                        <Form.Item
                                            label="Nationality"
                                            name="nationality"
                                            className="w50"
                                            rules={[{ required: true, message: "Nationality is required" }]}
                                        >
                                            <Input placeholder="Enter Nationality" maxLength={30} />
                                        </Form.Item>
                                    </div>
                                </div> */}
                                <div className="card-section">
                                    <div>
                                        <Title level={5} style={{ marginBottom: 25 }}>Address</Title>
                                        <Form.Item
                                            label="Street Address"
                                            name="physicalAddress"
                                            className="w50"
                                            rules={[{ required: true, message: "Street Address is required" }]}
                                        >
                                            <Input.TextArea placeholder="Enter Street Address" maxLength={500} autoSize={{ minRows: 1, maxRows: 5 }} />
                                        </Form.Item>


                                        <Form.Item
                                            label="City"
                                            name="city"
                                            className="w50"
                                            rules={[{ required: true, message: "City is required" }]}
                                        >
                                            <Input placeholder="Enter City" maxLength={30} />
                                        </Form.Item>

                                        <Form.Item
                                            label="State"
                                            name="state"
                                            className="w50"
                                            rules={[{ required: true, message: "State is required" }]}
                                        >
                                            <Input placeholder="Enter State" maxLength={30} />
                                        </Form.Item>

                                        {/* <Form.Item
                                            label="Zip Code"
                                            name="zipcode"
                                            className="w50"
                                            rules={[{ required: true, message: "Zip Code is required" }]}
                                        >
                                            <IntegerInput placeholder="Enter Zip Code" maxLength={6} />
                                        </Form.Item> */}

                                        <Form.Item
                                            label="Zip Code"
                                            name="zipcode"
                                            className="w50"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Zip Code is required',
                                                },
                                                {
                                                    pattern: /^\d{5}(-\d{4})?$/,
                                                    message: 'Enter a valid ZIP Code (e.g., 12345 or 12345-6789)',
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder="Enter Zip Code"
                                                maxLength={10} // Supports 12345-6789
                                            />
                                        </Form.Item>

                                        <Form.Item
                                            label="Years Of Residence"
                                            name="yearsOfResidence"
                                            className="w50"
                                        >
                                            <IntegerInput placeholder="Enter Years Of Residence" maxLength={30} />
                                        </Form.Item>

                                        {/* <Form.Item
                                            label="SSN / ITIN"
                                            name="ssnumber"
                                            className="w50"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'SSN Number is required',
                                                },
                                                // {
                                                //     pattern: /^\d{5}(-\d{4})?$/,
                                                //     message: 'Enter a valid ZIP Code (e.g., 12345 or 12345-6789)',
                                                // },
                                            ]}
                                        >
                                            <MaskedDigitsInput
                                                placeholder="Enter SSN Number"
                                                maxLength={10} // Supports 12345-6789
                                            />
                                        </Form.Item> */}
                                    </div>
                                </div>
                                <div className="card-section">
                                    <div>
                                        <Title level={5} style={{ marginBottom: 25 }}>Employment Details</Title>
                                        <Form.Item
                                            label="Employer Name"
                                            name="employerName"
                                            className="w50"
                                        >
                                            <Input placeholder="Enter Employer Name" maxLength={30} disabled />
                                        </Form.Item>

                                        <Form.Item
                                            label="Employer Business Phone"
                                            name="employerBusinessPhone"
                                            className="w50"
                                            rules={[
                                                { required: false, message: "Employer Business Phone is required" },
                                                {
                                                    validator: (_, value) => {
                                                        if (!value) {
                                                            return Promise.resolve(); //  Allow empty value if not required
                                                        }
                                                        const digits = value.replace(/\D/g, '');
                                                        if (digits.length === 10) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(
                                                            new Error("Wrong format! please use this format (XXX) XXX-XXXX")
                                                        );
                                                    },
                                                }
                                            ]}
                                        >
                                            <PhoneInput
                                                placeholder="Enter Employer Business Phone"
                                                inputComponent={Input}
                                                autoComplete="off"
                                                onChange={(value) => {
                                                    // Remove non-digit characters and store the raw number
                                                    const digits = value.replace(/\D/g, '');
                                                    form.setFieldsValue({ employerBusinessPhone: digits });
                                                }}
                                                disabled
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Employer Street Address"
                                            name="employerStreetAddress"
                                            className="w50"
                                        >
                                            <Input placeholder="Enter Employer Street Address" maxLength={100} disabled />
                                        </Form.Item>
                                        <Form.Item
                                            label="Employer City"
                                            name="employerCity"
                                            className="w50"
                                        >
                                            <Input placeholder="Enter Employer City" maxLength={30} disabled />
                                        </Form.Item>
                                        <Form.Item
                                            label="Employer State"
                                            name="employerState"
                                            className="w50"
                                        >
                                            <Input placeholder="Enter Employer State" maxLength={30} disabled />
                                        </Form.Item>
                                        <Form.Item
                                            label="Employer Zip Code"
                                            name="employerZip"
                                            className="w50"
                                        >
                                            <IntegerInput placeholder="Enter Employer Zip Code" maxLength={30} disabled />
                                        </Form.Item>
                                        <Form.Item
                                            label="No. Of Years"
                                            name="employerNoofYears"
                                            className="w50"
                                        >
                                            <IntegerInput placeholder="Enter No. Of Years" maxLength={3} />
                                        </Form.Item>
                                        <Form.Item
                                            label="Position/Title"
                                            name="employerPositionTitle"
                                            className="w50"
                                        >
                                            <Input placeholder="Enter Position/Title" maxLength={30} />
                                        </Form.Item>
                                        <Form.Item
                                            label="No. Of Dependents"
                                            name="employerNoofDependents"
                                            className="w50"
                                        >
                                            <IntegerInput placeholder="Enter No. Of Dependents" maxLength={3} />
                                        </Form.Item>
                                        <Form.Item
                                            label="Age Of Dependents"
                                            name="employerAgeOfDependents"
                                            className="w50"
                                        >
                                            <Input
                                                placeholder="Enter Age Of Dependents"
                                                maxLength={3}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow only digits and commas
                                                    const filteredValue = value.replace(/[^0-9,]/g, '');

                                                    // Update the input value directly
                                                    e.target.value = filteredValue;

                                                    // If you have form instance, update the form value here:
                                                    form.setFieldsValue({ employerAgeOfDependents: filteredValue });
                                                }}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>

                                {/* <Form.Item
                           
                            label="Photo Of ID"
                            name="PhotoOfID"

                            rules={[
                                {
                                    required: true,
                                    validator() {
                                        if (imagePath && imagePath !== "") {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error("Photo Of ID is required"));
                                    },
                                },
                            ]}
                        >
                            <Upload
                                name="image"
                                accept=".png,.jpeg,.jpg"
                                beforeUpload={preventRequest}
                                onRemove={removeFile}
                                listType="picture-card"
                                showUploadList={false}
                                maxCount={1}
                            >
                                {imagePath ? (
                                    <img
                                        src={imagePath}
                                        alt="Photo Of ID"
                                        style={{ width: "100%", maxWidth: "200px" }}
                                    />
                                ) : (
                                    <div>
                                        <UploadOutlined />
                                        <div>Click to Upload</div>
                                    </div>
                                )}
                            </Upload>
                            {fileFormatText}
                        </Form.Item> 
  */}

                                {/* <Form.Item
                                label="Photo Of ID"
                                name="PhotoOfID"
                                rules={[
                                    {
                                        required: true,
                                        validator() {
                                            if ((imagePath && imagePath !== "") || (applicantInfo && applicantInfo.PhotoOfID)) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error("Photo Of ID is required"));
                                        },
                                    },
                                ]}
                            >
                              
                                {imagePath && imagePath != "" ? (
                                    <div id="imgDiv" className="imgDiv mb10">
                                        <Tooltip title="Download Photo Of ID">
                                            <a
                                                href={APP_BLOB_ROOT + imagePath}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                download
                                            >
                                                <img
                                                    id="logoImage"
                                                    className="logoImg"
                                                    src={APP_BLOB_ROOT + imagePath}
                                                    alt="Uploaded ID"
                                                />
                                            </a>
                                        </Tooltip>
                                        <Tooltip title="Delete Photo Of ID">
                                            <Button
                                                id="deleteLogoBtn"
                                                type="text"
                                                icon={<DeleteOutlined />}
                                                danger
                                                onClick={onDeleteImage}
                                            />
                                        </Tooltip>

                                    </div>
                                ) : (
                                    <Upload
                                        accept="image/png,image/jpeg,image/gif,image/bmp"
                                        beforeUpload={preventRequest}
                                        onRemove={removeFile}
                                        listType="picture"
                                        maxCount={1}
                                    >
                                        <Button id="clickToUploadBtn" className="mb10" icon={<UploadOutlined />}>
                                            Click to Upload
                                        </Button>
                                    </Upload>
                                )}
                                <div>{fileFormatText}</div>
                            </Form.Item> */}



                                <Form.Item>
                                    <div style={{ display: "flex", gap: 16, marginTop: 20 }}>
                                        <ButtonComponent
                                            text="Go Back"
                                            onClick={onBack}
                                            type="default"

                                        />
                                        <ButtonComponent
                                            text={
                                                <span>
                                                    Save And Proceed <ArrowRightOutlined />
                                                </span>
                                            }
                                            // text="Save And Proceed"
                                            htmlType="submit"
                                            disabled={![1, 2, 4, 9].includes(applicantInfo && applicantInfo.Application_Status_Id) ? true : false}
                                            icon={<RightOutlined />}
                                        />
                                    </div>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </div>
                {/*</div>   */}
            </LeftLayout>
        </Spin>
    );
};

export default ApplicantsIdentification;